import { truncateString } from "@/utils";
import FilterItem from "./FilterItem.vue";
import CampaignGroupFilterBody from "./bodies/CampaignGroupFilterBody.vue";
import FiltersMixin from "@/mixins/FiltersMixin.vue";
export default {
  name: "CampaignGroupsFilter",
  components: {
    FilterItem,
    CampaignGroupFilterBody
  },
  emits: ["apply", "cleared"],
  expose: ["openDropdown"],
  mixins: [FiltersMixin],
  props: {
    campaign_groups: {
      type: Object,
      required: true
    },
    sellers: {
      type: Object,
      required: true
    },
    marketplaces: {
      type: Object,
      required: true
    }
  },
  computed: {
    getCampaignGroupTitle() {
      let joinedContents = this.campaign_groups.selected.map(el => el?.name).join(", ");
      joinedContents = joinedContents.length > 0 ? joinedContents : 'CampaignGroupss';
      return truncateString(joinedContents, 16);
    },
    getCampaignGroupSelectedTitle() {
      const joined = this.campaign_groups.selected.map(el => el?.name).join(", ");
      return joined.length > 0 ? truncateString(joined, 200) : "";
    }
  },
  methods: {
    handleCampaignGroupsSearch({
      value
    }) {
      // If value is empty, clear the searching state
      if (value.length === 0) {
        this.campaign_groups.searching = false;
      }
      this.campaign_groups.asyncSearch({
        keyword: value,
        args: {
          sellers: this.sellers.filterValues,
          sales_channel: this.marketplaces.filterValues
        }
      });
    },
    handleClear() {
      this.campaign_groups.clear();
      this.$emit('cleared');
    },
    onRestoreSearch() {
      this.campaign_groups.restoreSearch();
    },
    handleSelect({
      id
    }) {
      this.campaign_groups.select({
        id
      }, 'id');
    },
    handleSelectOnly({
      id
    }) {
      this.campaign_groups.selectOnly({
        id
      }, 'id');
    },
    handleDeselect({
      id
    }) {
      this.campaign_groups.deselect({
        id
      }, 'id');
      if (this.campaign_groups?.filterState?.selected.length === 0) {
        this.$emit('cleared');
      }
    },
    handleClearAll() {
      this.campaign_groups.clear();
      this.$emit('cleared');
    },
    onDiscard() {
      // Revert the staged pending changes back to the last-applied selection.
      this.campaign_groups.clearDraft();
    },
    onHidden() {
      this.campaign_groups.clearDraft();
    },
    onApply() {
      this.$emit('apply');
    },
    openDropdown(initializer = async () => {}, callback = () => {}) {
      this.openAsyncFilterDropdown(this.$refs.campaignGroupsFilterItem, initializer, callback);
    }
  }
};